import actions from './billing/actions'
import mutations from './billing/mutations'
import getters from './billing/getters'

export const initialState = () => {
  return {
    paymentsAvailable: true,
    paymentHistory: [],
    paymentHistoryLoading: true,
    invoicePaymentHistory: [],
    invoicePaymentHistoryLoading: true,
    invoicePaymentHistoryUserMessage: '',
    currentPaymentMethod: {},
    paymentLobs: [],
    paymentMethodsLoading: false,
    userPaymentMethods: [],
    userPaymentMethodsLoading: false,
    paymentConfirmation: {},
    payment: {},
    onetimePaymentDetails: {},
    recurringPaymentsForm: {
      optIn: true,
      agreeToTerms: false
    },
    invoiceSearchForm: {
      status: null // todo is this the proper default?
    },
    invoices: [],
    filteredInvoices: [],
    invoicesLoading: false,
    invoicesUserMessage: '',
    isBlocking: false,
    isUnBlocking: false,
    cybersourceDetailsLoading: false,
    cybersourceDetails: {
      amount: 0
    },
    autoPayDetails: {},
    autoPayDetailsLoading: false,
    singleInvoiceLoading: true,
    singleInvoice: {},
    invoiceDetailsError: false,
    invoiceDetailsErrorMessage: '',
    makingPayment: false,
    configuringRecurringPayments: false,
    deletingPaymentMethod: false,
    deletingUserPaymentMethod: false,
    updateDefaultPaymentMethodLoading: false,
    subGroupDetailsLoading: false,
    subGroupDetails: {},
    cashOnAccountsLoading: false,
    cashOnAccounts: 0.00,
    paymentHistoryConfigurationLoading: false,
    paymentHistoryEnabled: true
  }
}

export const billing = { namespaced: false, state: initialState(), mutations, actions, getters }
